import Header from '../../../components/Header'
import Aside from '../../../components/Aside'
import Footer from '../../../components/Footer'
import { useTranslation } from 'react-i18next'
import SideBar from './SideBar'
import GreetingPage from '../GreetingPage'
import { useEffect, useMemo, useState } from 'react'
import TicketChatView from './TicketChatView'
import { FollowUpTicketsContext } from '../../../context/FollowUpTicketsContext'
import { FollowUpService } from '../../../services/FollowUpService'
import { useCurrentAccount } from '../../../hooks/useCurrentAccount'
import { AlertService } from '../../../services/Alert'
import { NumberUtil } from '../../../utils/number'
import * as socketIO from 'socket.io-client';
import { DateUtil } from '../../../utils/date'
import * as XLSX from 'xlsx';
import moment from 'moment'
import useRequest from '../../../hooks/useRequest'
import LoaderSmall from '../../../components/LoaderSmall'
import Select from 'react-select';
export default function FollowUpTicketsPage() {

  const { t } = useTranslation();
  const { call: callCards, isRequesting: isRequestingCards } = useRequest();
  const [ticketSelected, setTicketSelected] = useState(null);
  const [newMessage, setNewMessage] = useState(null);
  const [info, setInfo] = useState(undefined);
  const { account } = useCurrentAccount();
  const [tickets, setTickets] = useState([]);
  const [timeOptions, setTimeOptions] = useState([]);
  const [selectedInterval, setSelectedInterval] = useState({ value: 2, label: `2 ${t('date-time.minutes')}` });
  const [lastUpdate, setLastUpdate] = useState('00:00:00');
  const [filters, setFilters] = useState<any>();
  const [subAccount, setSubAccount] = useState([]);
  const [totalTickets, setTotalTickets] = useState(0)

  const getCards = async () => {
    const { data } = await callCards(() => FollowUpService.getTicketsCard(account.id));
    setInfo(data);

  }

  const getTickets = async () => {
    const { data } = await FollowUpService.getOpenTickets(account.id);
    setTotalTickets(data.length);
    setTickets(data);
  }

  const updateCurrentTime = () => {
    const currentTime = new Date().toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
    setLastUpdate(currentTime);
  };

  const connectIO = () => {
    const url = FollowUpService.getURLSocket(account.id)

    const socket = socketIO(url);

    socket.on('connect', () => {
      // console.log('connect')
    })

    socket.on('disconnect', (reason) => {
      // console.log('se desconecto', reason)
    })
    socket.on('connect_error', (error) => {
      // console.log('connect_error', error)
    })
    socket.on('error', (error) => {
      // console.log('error', error)
    })
    socket.on('newTicket', (payload) => {
      console.log('newTicket', payload)
    })
    socket.on('newMessages', (payload) => {
      console.log('newMessages', payload)
      setNewMessage(payload)
    })
  }

  const exportExcel = () => {
    if (tickets.length === 0) {
      AlertService.toastError("No hay información para descargar.");
      return;
    }

    let filteredTickets = tickets.filter(ticket => {
      if (filters.tsra && filters.tsrc) {
        return true;
      } else if (filters.tsra) {
        return ticket._status_ticket === 'tsra';
      } else if (filters.tsrc) {
        return ticket._status_ticket === 'tsrc';
      } else if (subAccount.length > 0) {
        return subAccount.filter(sub => sub.label === ticket.sub_account).length > 0;
      }
      return true;
    });
    
    if (filteredTickets.length === 0) {
      AlertService.toastError("No hay información para descargar.");
      return;
    }

    const HEADER = [
      'ID',
      'NÚMERO',
      'ASIGNADO A',
      'PRIMER MENSAJE DEL AGENTE',
      'TIEMPO ABIERTO',
      'FECHA DE INICIO',
      'FECHA DE ASIGNACIÓN',
      'TIEMPO SIN ACTIVIDAD',
      'ETIQUETA',
      'COMENTARIOS SEGUIMIENTO'
    ]
    const rows = filteredTickets.map(row => {
      return {
        'ID': row.id,
        'NÚMERO': row.chat_number.replace('@c.us', ''),
        'ASIGNADO A': row.assing_to,
        'PRIMER MENSAJE DEL AGENTE': row.first_message_agent,
        'TIEMPO ABIERTO': DateUtil.diff(row.date_init, moment()),
        'FECHA DE INICIO': row.date_init,
        'FECHA DE ASIGNACIÓN': row.date_assignment,
        'TIEMPO SIN ACTIVIDAD': row.time_with_out_activity,
        'ETIQUETA': row.label_ticket,
        'COMENTARIOS SEGUIMIENTO': null
      }
    })
    const wb = XLSX.utils.book_new();

    const ws = XLSX.utils.json_to_sheet(rows, {
      header: HEADER,
    });

    XLSX.utils.book_append_sheet(wb, ws);
    return XLSX.writeFile(wb, `reporte-tickets-abiertos.xlsx`);
  }

  const handleIntervalChange = (selectedOption) => {
    setSelectedInterval(selectedOption);
  };

  const handleFiltersChange = (activeFilters, selectedSubAccount) => {
    setFilters(activeFilters);
    setSubAccount(selectedSubAccount);
  };

  useEffect(() => {
    updateCurrentTime();
    getCards();
    connectIO();
  }, [])

  useEffect(() => {
    getCards();
    getTickets();
    connectIO();
    const options = [];
    for (let i = 2; i <= 30; i += 2) {
      options.push({ value: i, label: ` ${i} ${t('date-time.minutes')}` });
    }
    setTimeOptions(options);
  }, [])

  useEffect(() => {
    const handleUpdateTickets = () => {
      getCards();
      getTickets();
      connectIO();
    };
    window.addEventListener('updateTickets', handleUpdateTickets);
    return () => {
      window.removeEventListener('updateTickets', handleUpdateTickets);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      updateCurrentTime();
      getCards();
      getTickets();
      connectIO();
    }, selectedInterval.value * 60 * 1000);

    return () => clearInterval(interval);
  }, [selectedInterval]);

  const heightRequesting = useMemo(() => { return isRequestingCards ? 'h-110' : '' }, [isRequestingCards]);
  return (
    <>
      <Header />
      <Aside />
      <main id="content" role="main" className="main">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col-sm mb-2 mb-sm-0">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb breadcrumb-no-gutter">
                    <li className="breadcrumb-item">
                      <span className="breadcrumb-link">{t('reports.operation-title')}</span>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {t('follow-up.header.follow-up-title')}
                    </li>
                  </ol>
                </nav>
                <h1 className="page-header-title text-white-dark">
                  <i className="bi-chat-left-dots-fill text-primary"></i> {t('follow-up.header.follow-up-title')} - {t('follow-up.header.tickets-title')}
                </h1>
              </div>
              <div className="col-sm-auto">
                <div className='d-flex align-items-center'>
                  <small className="text-primary bold mb-0 mt-2 text-white-dark">{t('follow-up.header.update-tickets')} </small>
                  <div className="p-2">
                    <div className="row" onClick={(e) => e.stopPropagation()}>
                      <div className="col">
                        <Select
                          options={timeOptions}
                          className={'tom-select-custom tom-select-custom-with-tags'}
                          classNamePrefix='form-select-custom'
                          onChange={handleIntervalChange}
                          value={selectedInterval}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="p-2">
                    <button className="btn btn-primary btn-md" onClick={exportExcel}>
                      <i className="bi bi-download me-1"></i>{t('follow-up.header.btn-download')}
                    </button>
                  </div>
                </div>
                <small className="d-flex justify-content-end fs-6 text-white-dark fw-bolder">{t('follow-up.header.last-update', { time: lastUpdate })}
                </small>
              </div>


            </div>
          </div>

          <div className="mb-3 mb-lg-5">
            <div className={`row relative ${heightRequesting}`}>
              {
                isRequestingCards ? <LoaderSmall /> :
                  <>
                    <div className="col-lg-3 ">
                      <div className="card card-sm">
                        <div className="card-body">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <h6 className="card-subtitle mb-3">{t('follow-up.cards.total-tickets')}</h6>
                              <div className="">
                                <h1 className="card-title">{NumberUtil.format(info?.tt)}</h1>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 ">
                      <div className="card card-sm">
                        <div className="card-body">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <h6 className="card-subtitle mb-3">{t('follow-up.cards.no-response-tickets')}</h6>
                              <div className="">
                                <h1 className="card-title">{NumberUtil.format(info?.ttsra)}</h1>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 ">
                      <div className="card card-sm">
                        <div className="card-body">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <h6 className="card-subtitle mb-3">{t('follow-up.cards.no-response-clients')}</h6>
                              <div className="">
                                <h1 className="card-title">{NumberUtil.format(info?.ttsrc)}</h1>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="card card-sm">
                        <div className="card-body">
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <h6 className="card-subtitle mb-3">{t('follow-up.cards.not-assigned')}</h6>
                              <div className="">
                                <h1 className="card-title">{NumberUtil.format(info?.tsa)}</h1>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
              }
            </div>
            <div className='row mt-3 p-2'>
              <FollowUpTicketsContext.Provider value={{ ticketSelected, setTicketSelected, newMessage, setNewMessage }}>

                <SideBar selectedInterval={selectedInterval} onFiltersChange={handleFiltersChange}  totalTickets={totalTickets}/>
                {ticketSelected ? (
                  <TicketChatView />
                ) : (
                  <GreetingPage />
                )}

              </FollowUpTicketsContext.Provider>
            </div>
          </div>
        </div>
        <Footer />
      </main>
    </>
  )
}
